export default __webpack_public_path__ + "assets/thermometer-warmer.5f9dfc8c.svg";